import styled, { keyframes, css } from 'styled-components';
import { getStyle as get } from '@ids/ddms-styled/comps/tile/intuit/light';

const tileFontFamily =
  'Avenir Next forINTUIT,Avenir,Helvetica,Arial,sans-serif';

export const Wrapper = styled.div`
  ${props =>
    props.a11yFocus &&
    `
    input:focus + label {
      outline: none;
      border: ${
        props.checked ? '1px solid rgba(44, 160, 28, 0.5)' : '1px solid #D4D7DC'
      };
      box-shadow: ${
        props.checked
          ? '0 0 0 1px #ffffff,0 0 0 2px rgba(0, 119, 197, 0.5)'
          : '0 0 0 1px #ffffff,0 0 0 2px rgba(0, 119, 197, 0.5)'
      };
    }
  `}
`;

export const Input = styled.input`
  opacity: 0;
  position: absolute;
`;

// padding and line-height are temporary solutions for QBO
export const Label = styled.label`
  min-height: 156px;
  width: 180px;
  border: ${get('border.stroke')} solid transparent;
  background-color: ${get('background.color')};
  border-radius: ${get('background.radius')};
  padding: 20px !important;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.2);
  cursor: pointer;
  font: ${get('body.fontStyle')} ${get(
  'body.fontWeight'
)} 12px ${tileFontFamily};
  line-height: ${get('body.lineHeight')} !important;
  color: ${get('body.color')};
  box-sizing: border-box;
  text-align:center;
  display: flex;
  flex-direction: column;
  outline: none;
  &:hover, &:focus {
    box-shadow: 0 6px 24px 0 rgba(0,0,0,0.2);
  }
  &:active {
    border: 1px solid #D4D7DC;
    box-shadow: 0 0 0 0 rgba(0,0,0,0.2);
    outline: none;
  }
  transition: box-shadow 250ms;
  ${props =>
    props.isMobile &&
    `
    width:100%;
    min-width: 100%;
    min-height: 84px;
    flex-direction: row;
  `}
  ${props =>
    !props.title &&
    `
    height: 156px;
  `}
  ${props =>
    !props.title &&
    props.isMobile &&
    `
    height: 84px;
  `}
  ${props =>
    props.checked &&
    props.title &&
    `
    background: rgba(44, 160, 28, 0.1);
    border: 1px solid rgba(44, 160, 28, 0.5);
    outline-offset: 1px;
    outline: none;
    &:hover {
      box-shadow: 0 6px 24px 0 rgba(0,0,0,0.2);
      outline: none;
    }
    &:active {
      box-shadow: 0 0 0 0 rgba(0,0,0,0.2);
      outline: none;
    }
  `}
  ${props =>
    !props.title &&
    !props.description &&
    props.checked &&
    `
    border: 1px solid ${get('border.color.selected')};
    outline-offset: 1px;
    outline: none;
  `}
`;

const idsTileFadeIn = keyframes`
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
    transition: transform 0.3s cubic-bezier(0.35,1.55,0.76,1);
  }
`;

const idsTileFadeOut = keyframes`
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
    transition: transform cubic-bezier(0.35,1.55,0.76,1) 0.3s;
  }
`;

export const IconContainer = styled.div`
  ${props =>
    props.title &&
    `
    padding: ${get('image.spacing')};
    min-height: 76px;
    height: 76px;
  `}
  ${props =>
    props.title &&
    props.isMobile &&
    `
    padding: 0;
    min-height: 44px;
    height: 0;
    margin-right: 16px;
  `}
  ${props =>
    !props.title &&
    !props.description &&
    `
    margin: auto;
    height: 100%;
    display: flex;
  `}
  ${props =>
    props.title &&
    props.checked &&
    props.mounted &&
    css`
      animation: ${idsTileFadeIn} 250ms;
    `}
  ${props =>
    props.title &&
    !props.checked &&
    props.mounted &&
    css`
      animation: ${idsTileFadeOut} 250ms;
    `}
`;

export const InfoContainer = styled.div`
  ${props =>
    props.title &&
    `
    text-align: center;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  `}
  ${props =>
    props.title &&
    props.isMobile &&
    `
    text-align: left;
    display: flex;
    flex-direction: column;
  `}
  word-break: break-word;
`;

export const Title = styled.p`
  font: ${get('title.fontStyle')} ${get('title.fontWeight')}
    ${get('title.fontSize')} / ${get('title.lineHeight')} ${tileFontFamily};
  color: ${get('title.color')};
  margin: auto;
  ${props =>
    props.isMobile &&
    `
    margin-left: 0;
  `}
`;

export const CheckedIcon = styled.div`
  margin: auto;
  background-color: transparent;
  width: 100%;
  height: 100%;
  position: relative;
  svg {
    position: absolute;
    left: calc(50% - 24px);
    bottom: 6px;
    width: 48px;
    height: 48px;
    fill: #53b700;
  }
  ${props =>
    props.iconSize &&
    props.isMobile &&
    `
    height: 44px;
    width: ${props.iconSize === 'large' ? '84px' : '44px'};
    svg {
      width: 36px;
      height: 36px;
      margin-left: ${props.iconSize === 'large' ? '8px' : '6px'};
      margin-top: ${props.iconSize === 'large' ? '15px' : '6px'};
    } 
  `}
`;

export const Icons = styled.div`
  ${props =>
    !props.title &&
    !props.description &&
    `
    width: 124px;
    height: 60px;
    margin: ${props.isMobile ? '0' : 'auto'};
    align-self: center;
    svg {
      width: 124px;
      height: 60px;
      fill: #53b700;
    }
  `}
  ${props =>
    (props.title || props.description) &&
    `
    margin: auto;
    width: ${props.iconSize === 'small' ? '60px' : '124px'};
    height: 60px;
    svg, img {
      width: ${props.iconSize === 'small' ? '60px' : '124px'};
      height: 60px;
      fill: #53b700;
    }
  `}
  ${props =>
    props.isMobile &&
    `
    margin: auto;
    width: ${props.iconSize === 'small' ? '44px' : '84px'};
    height: 44px;
    svg, img {
      width: ${props.iconSize === 'small' ? '44px' : '84px'};
      height: 44px;
    }
  `}
`;
